import { Suspense, type ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { matchPath, useLocation } from "react-router";
import { cn } from "@/lib/utils";
import { Notification } from "@/components/admin/notification";
import { Error } from "@/components/admin/error";
import { Skeleton } from "@/components/ui/skeleton";

import { DataImportProvider } from "../dataImport/DataImportProvider";
import { useConfigurationLoader } from "../root/useConfigurationLoader";
import Header from "./Header";
import { OnboardingProvider, OnboardingStory } from "../onboarding";
import { AccountLocaleSync } from "../projects/LocaleSelector";
import { AccountCurrencySync } from "../projects/CurrencySelector";

export const Layout = ({ children }: { children: ReactNode }) => {
  useConfigurationLoader();
  // La liste des projets prend toute la largeur : elle partage l'écran avec la fiche ouverte.
  const wide = !!matchPath("/projects/*", useLocation().pathname);
  return (
    <DataImportProvider>
      <OnboardingProvider>
        <AccountLocaleSync />
        <AccountCurrencySync />
        <Header />
        <main className="min-h-dvh pl-20" id="main-content">
          <div className={cn("p-4", !wide && "mx-auto max-w-screen-xl")}>
            <ErrorBoundary FallbackComponent={Error}>
              <Suspense
                fallback={<Skeleton className="h-12 w-12 rounded-full" />}
              >
                {children}
              </Suspense>
            </ErrorBoundary>
          </div>
        </main>
        <OnboardingStory />
        <Notification />
      </OnboardingProvider>
    </DataImportProvider>
  );
};
